export enum MultiPlanProtectionDetailsVariants {
  Control = 'control',
  Test = 'test',
}
